/* eslint-disable import/prefer-default-export */
import graphqlClient from 'api/graphql';

import { listDrugsGql } from './gql';

export const listDrugsApi = ({ medicationName }) => {
  return graphqlClient.request(listDrugsGql, { medicationName }).then(({ listDrugs }) => listDrugs);
};
